export default __webpack_public_path__ + "static/media/429.59262577.jpg";